import { createSlice } from "@reduxjs/toolkit";
import {
    getMonthlyUpdate, getOverAllEmployeeUpdates, getAttendanceStatusUpdate, getWeeklyAISummary, getMonthlyAISummary, getOverallAISummary
} from './thunk';
import {
    getGamificationStats, updateGamificationStats, getGamificationBadges, recordDailyUpdatePoints
} from './gamificationThunk';

export const initialState = {
    dailyUpdatesList: [],
    weeklyAISummary: null,
    monthlyAISummary: null,
    overallAISummary: null,
    gamificationStats: null,
    gamificationBadges: [],
    errors: {}
};

const DailyUpdateSlice = createSlice({
    name: 'DailyUpdates',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMonthlyUpdate.fulfilled, (state: any, action: any) => {
            state.dailyUpdatesList = action.payload;
        });
        builder.addCase(getMonthlyUpdate.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getOverAllEmployeeUpdates.fulfilled, (state: any, action: any) => {
            state.dailyUpdatesList = action.payload;
        });
        builder.addCase(getOverAllEmployeeUpdates.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getAttendanceStatusUpdate.fulfilled, (state: any, action: any) => {
            state.dailyUpdatesList = action.payload;
        });
        builder.addCase(getAttendanceStatusUpdate.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        
        // AI Summary cases
        builder.addCase(getWeeklyAISummary.fulfilled, (state: any, action: any) => {
            state.weeklyAISummary = action.payload;
        });
        builder.addCase(getWeeklyAISummary.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        
        builder.addCase(getMonthlyAISummary.fulfilled, (state: any, action: any) => {
            state.monthlyAISummary = action.payload;
            state.error = null;
        });
        builder.addCase(getMonthlyAISummary.rejected, (state: any, action: any) => {
            state.error = action.payload || 'Failed to generate monthly summary';
            state.monthlyAISummary = null;
        });
        
        builder.addCase(getOverallAISummary.fulfilled, (state: any, action: any) => {
            state.overallAISummary = action.payload;
            state.error = null;
        });
        builder.addCase(getOverallAISummary.rejected, (state: any, action: any) => {
            state.error = action.payload || 'Failed to generate overall summary';
            state.overallAISummary = null;
        });

        // Gamification cases
        builder.addCase(getGamificationStats.fulfilled, (state: any, action: any) => {
            state.gamificationStats = action.payload;
        });
        builder.addCase(getGamificationStats.rejected, (state: any, action: any) => {
            state.error = action.payload || null;
        });

        builder.addCase(updateGamificationStats.fulfilled, (state: any, action: any) => {
            state.gamificationStats = action.payload;
        });
        builder.addCase(updateGamificationStats.rejected, (state: any, action: any) => {
            state.error = action.payload || null;
        });

        builder.addCase(getGamificationBadges.fulfilled, (state: any, action: any) => {
            state.gamificationBadges = action.payload || [];
        });
        builder.addCase(getGamificationBadges.rejected, (state: any, action: any) => {
            state.error = action.payload || null;
        });

        builder.addCase(recordDailyUpdatePoints.fulfilled, (state: any, action: any) => {
            // Update stats after recording points
            if (action.payload?.stats) {
                state.gamificationStats = action.payload.stats;
            }
        });
        builder.addCase(recordDailyUpdatePoints.rejected, (state: any, action: any) => {
            state.error = action.payload || null;
        });
    }
});

export default DailyUpdateSlice.reducer;